import { IClasse } from './classe.model';
import { ISupport } from './support.model';
import { IMatiereEcole } from './matiere.model';
import { ICours } from './cours.model';
import { IPointage } from './pointage.model';
import { IAbsence } from './absence.model';

export interface IProfesseur {
  id?: string;
  prenom?: string;
  nom?: string;
  matricule?: string;
  matieresEcole?: IMatiereEcole[];
  cours?: ICours[] | null;
  classes?: IClasse[] | null;
  telephone?: string;
  ecoleId?: string;
  adresse?: string;
  support?: ISupport | null;
  statutPresence?: string;
  tauxHoraire?: number;
  moyenPaiement?: string;
  numeroTelephonePaiement?: string;
  brs?: boolean;
  salaireMensuel?: number;
  validated?: boolean;
  validationKey?: string;
  keyCreatedTime?: string;
  keyExpirationTime?: string;
  pointages?: IPointage[] | null;
  absences?: IAbsence[] | null;
  poste?: string;
  typePersonnel?: string;
  login?: string;
  password?: string;
  email?: string;
  page?: number;
  size?: number;
}

export const defaultValue: Readonly<IProfesseur> = {
  id: null,
  prenom: '',
  nom: '',
  matricule: '',
  classes: [],
  telephone: '',
  statutPresence: null,
  tauxHoraire: 0,
  salaireMensuel: 0,
  brs: false,
  moyenPaiement: null,
  numeroTelephonePaiement: '',
  validated: false,
  cours: [],
  adresse: '',
  support: null,
  ecoleId: '',
  pointages: null,
  absences: [],
  poste: '',
  typePersonnel: null,
  login: '',
  email: '',
  password: '',
  page: 0,
  size: 0,
};
